/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
	document.addEventListener("DOMContentLoaded", function () {
		// If url contains .com/products/ make sure page is scrolled to top

		if (window.location.href.indexOf(".com/products/") > -1) {
			window.scrollTo(0, 0);
		}
	});

	let productGridSwatches = document.querySelectorAll(
		".product-grid-item .swatch__button"
	);

	const productPageSwatches = document.querySelectorAll(
		".product-page .swatch__button"
	);
	const productPageSizeSelector = document.querySelectorAll(
		'.product-page .selector-wrapper[data-select-label="Size"] .radio__inputs .radio__button'
	);
	const productPageMetafieldBadge = document.querySelector(
		".product-page .metafield--badge.anchor"
	);

	// When a grid swatch is clicked, update the product's price and image links
	let retryCount = 0;
	const maxRetries = 10;

	if (!productGridSwatches || productGridSwatches.length === 0) {
		const retryInterval = setInterval(() => {
			if (retryCount >= maxRetries) {
				clearInterval(retryInterval);
				return;
			}

			productGridSwatches = document.querySelectorAll(
				".product-grid-item .swatch__button"
			);

			if (productGridSwatches && productGridSwatches.length > 0) {
				clearInterval(retryInterval);
				handleGridSwatchClick();
			}

			retryCount++;
		}, 500);
	} else {
		handleGridSwatchClick();
	}

	function handleGridSwatchClick() {
		const collectionPageProducts = document.querySelector(
			".collection .collection__products, .collection-tabs .related__products"
		);

		if (!collectionPageProducts || collectionPageProducts.length === 0) {
			return;
		}

		const observer = new MutationObserver(function () {
			const productGridSwatches = document.querySelectorAll(
				".product-grid-item .swatch__button"
			);

			if (!productGridSwatches) {
				return;
			}

			productGridSwatches.forEach((swatch) => {
				swatch.addEventListener("click", updatePriceAndImageLinks);
				swatch.addEventListener("click", handleSwatchFocusManagement);
			});
		});

		observer.observe(collectionPageProducts, {
			childList: true,
			subtree: true,
		});

		productGridSwatches.forEach((swatch) => {
			swatch.addEventListener("click", updatePriceAndImageLinks);
			swatch.addEventListener("click", handleSwatchFocusManagement);
		});

		function handleSwatchFocusManagement(event) {
			const clickedElement = event.target.closest(".swatch__label");

			if (!clickedElement) {
				return;
			}

			const elementToRefocus = clickedElement;
			const productContainer = clickedElement.closest("product-grid-item");

			// Wait for DOM mutations to complete, then restore focus
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					// Sync aria-checked with aria-selected (theme.js uses aria-selected)
					if (productContainer) {
						const allSwatches =
							productContainer.querySelectorAll(".swatch__label");
						allSwatches.forEach((swatch) => {
							const isSelected =
								swatch.getAttribute("aria-selected") === "true";
							swatch.setAttribute(
								"aria-checked",
								isSelected ? "true" : "false"
							);
						});
					}

					// Restore focus to the clicked swatch for screen readers.
					if (
						elementToRefocus &&
						typeof elementToRefocus.focus === "function"
					) {
						elementToRefocus.focus();
					}
				});
			});
		}

		function updatePriceAndImageLinks(event) {
			const swatch = event.target.closest("radio-swatch");

			if (!swatch) {
				return;
			}

			const label = swatch.querySelector(".swatch__label");

			const productContainer = swatch.closest(".product-grid-item");
			const productInfoLink = productContainer.querySelector(
				".product__grid__info a"
			);
			const productImageLink = productContainer.querySelectorAll(
				".product-grid-item__container a"
			);
			const priceContainer = productContainer.querySelector(
				".product__grid__price .price"
			);
			const compareAtPriceContainer = productContainer.querySelector(
				".product__grid__price .compare-at"
			);

			const variantId = label.dataset.gridItemVariant;
			const variantPrice = label.dataset.variantPrice;
			const variantCompareAtPrice = label.dataset.variantCompareAtPrice;
			const saleCopy = label.dataset.saleCopy;

			// Update price
			if (compareAtPriceContainer) {
				if (Number(variantCompareAtPrice) > Number(variantPrice)) {
					compareAtPriceContainer.innerHTML =
						"$" + (variantCompareAtPrice * 0.01).toFixed(2);
					priceContainer.innerHTML =
						"$" + (variantPrice * 0.01).toFixed(2);
					priceContainer.classList.add("on-sale");
				} else {
					compareAtPriceContainer.innerHTML = "";
					priceContainer.innerHTML =
						"$" + (variantPrice * 0.01).toFixed(2);
					priceContainer.classList.remove("on-sale");
				}
			}

			// Update sale copy
			const saleCopyContainer =
				productContainer.querySelector("div[data-sale-copy]");
			if (saleCopyContainer) {
				// Try variant sale copy first, then fall back to product-level
				const productSaleCopyElement = productContainer.querySelector(
					"[data-product-sale-copy]"
				);
				const productSaleCopy = productSaleCopyElement?.getAttribute(
					"data-product-sale-copy"
				);
				const finalSaleCopy = saleCopy || productSaleCopy || "";

				saleCopyContainer.innerHTML = finalSaleCopy
					? `<p class="product__price--sale-copy">${finalSaleCopy}</p>`
					: "";
			}

			// Update URLs
			const url = new URL(productInfoLink.href);
			url.searchParams.set("variant", variantId);

			productInfoLink.href = url.pathname + "?" + url.searchParams;

			productImageLink.forEach((link) => {
				link.href = url.pathname + "?" + url.searchParams;
			});
		}

		function triggerElementClick(element) {
			element.click();
			element.dispatchEvent(new MouseEvent("mouseenter", { bubbles: true }));
		}
	}

	// When a product page swatch is clicked, update the product's model information
	if (
		productPageSwatches &&
		productPageSizeSelector &&
		productPageMetafieldBadge
	) {
		// Reset the model information when size is clicked (via a programmatic click)
		productPageSizeSelector.forEach((size) => {
			size.addEventListener("click", () => {
				Array.from(productPageSwatches).some((swatch) => {
					const input = swatch.querySelector("input");

					if (input.checked) {
						swatch.click();
						return true;
					}
				});
			});
		});

		// Find the model information for the selected swatch when clicked
		productPageSwatches.forEach((swatch) => {
			swatch.addEventListener("click", () => {
				const dataset = swatch.dataset;
				const anchorKey = swatch.dataset.anchorKey.replace(" ", "");
				const pinKey = "modelInfo";

				let currentSize = null;
				let modelInfo = null;

				// Find the current size
				productPageSizeSelector.forEach((size) => {
					const input = size.querySelector("input");

					if (input.checked) {
						currentSize = input.value.toLowerCase();
					}
				});

				// Find the model information for the selected swatch
				for (const key in dataset) {
					// Return if dataset is not model info or if model info is left empty
					if (!key.includes(pinKey) || !dataset[key]) {
						continue;
					}

					// Get the first model info as a default
					if (!modelInfo) {
						modelInfo = dataset[key];
					}

					// Get the size key from the dataset key
					const sizeKey = key.split(pinKey + anchorKey)[1].toLowerCase();

					// If the size key matches the current size, set the model info
					if (sizeKey && currentSize && sizeKey === currentSize) {
						modelInfo = dataset[key];
						break;
					}
				}

				// Update the model information on the product page
				if (productPageMetafieldBadge) {
					productPageMetafieldBadge.innerHTML = modelInfo
						? modelInfo
						: productPageMetafieldBadge.dataset.default;
				}

				addModelInfoToFirstImage();
			});

			// Click the first selected swatch
			const input = swatch.querySelector("input");

			if (input.checked) {
				swatch.click();
			}
		});
	}

	// TODO: Update model information functions to update the HIDDEN (anchor) model information on the product page

	// TODO: Inject model information into the first image of the product page. When observe mutation, replace the first image with the model information.
	const productMediaWrapper = document.querySelector(
		".product-page .product__media__wrapper"
	);

	if (productMediaWrapper) {
		const observer = new MutationObserver((mutationRecords) => {
			let isBadgeMutation = false;

			if (mutationRecords) {
				mutationRecords.forEach((record) => {
					if (record.addedNodes) {
						record.addedNodes.forEach((node) => {
							if (
								node.classList &&
								node.classList.contains("metafield--badge")
							) {
								isBadgeMutation = true;
							}
						});
					}
				});
			}

			if (!isBadgeMutation) {
				addModelInfoToFirstImage();
			}
		});
		observer.observe(productMediaWrapper, {
			childList: true,
			subtree: true,
		});
	}

	// TODO: On load, run the addToFirstImage function
	addModelInfoToFirstImage();

	// TODO: When a swatch is clicked, run the addToFirstImage function
	// TODO: Create a function to add model information to the first image, remove the current visible model information

	// Get the product page product container

	function addModelInfoToFirstImage() {
		// Find the hidden model info (truth of source)
		const productPageModelInfo = document.querySelector(
			".product-page .metafield--badge.anchor"
		);
		const productImageGrid = document.querySelectorAll(
			".product-page .product__grid"
		);

		// console.log("malik -- addModelInfoToFirstImage", productPageModelInfo, productImageGrid, productImageGridCount, productImageGrid.length);
		// console.log("malik -- addModelInfoToFirstImage");

		if (
			!productPageModelInfo ||
			!productImageGrid ||
			productImageGrid.length === 0
		) {
			return;
		}

		// Find the first image on the product page
		productImageGrid.forEach((grid) => {
			const firstImage = grid.querySelector(".product__media");

			if (firstImage) {
				// Remove any visible model information
				const visibleModelInfo =
					firstImage.querySelector(".metafield--badge");

				if (visibleModelInfo) {
					visibleModelInfo.remove();
				}

				// Add the model information to the first image
				const modelInfo = productPageModelInfo.cloneNode(true);
				modelInfo.classList.remove("anchor");
				firstImage.appendChild(modelInfo);
			}
		});
	}

	function initProductGridKeyboardNavigation() {
		const collectionGrid = document.querySelector(
			".collection__products .js-grid"
		);

		if (!collectionGrid) {
			return;
		}

		const getProductCards = () => {
			return Array.from(
				collectionGrid.querySelectorAll("product-grid-item")
			);
		};

		const getFirstFocusable = (card) => {
			const productLink = card.querySelector("[data-grid-link]");
			if (productLink) return productLink;

			const focusables = card.querySelectorAll(
				'a, button, [tabindex]:not([tabindex="-1"])'
			);
			return focusables[0] || null;
		};

		const getColumnCount = () => {
			const gridElement = collectionGrid;
			const gridLarge = parseInt(gridElement.dataset.gridLarge) || 3;
			const gridSmall = parseInt(gridElement.dataset.gridSmall) || 2;

			return window.innerWidth >= 768 ? gridLarge : gridSmall;
		};

		const handleKeyDown = (event) => {
			if (
				!["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(
					event.key
				)
			) {
				return;
			}

			const currentCard = event.target.closest("product-grid-item");
			if (!currentCard) {
				return;
			}

			const productCards = getProductCards();
			const currentIndex = productCards.indexOf(currentCard);

			if (currentIndex === -1) {
				return;
			}

			const columns = getColumnCount();
			let targetIndex = -1;

			switch (event.key) {
				case "ArrowDown":
					targetIndex = currentIndex + columns;
					break;
				case "ArrowUp":
					targetIndex = currentIndex - columns;
					break;
				case "ArrowRight":
					targetIndex = currentIndex + 1;
					if (
						Math.floor(targetIndex / columns) !==
						Math.floor(currentIndex / columns)
					) {
						return;
					}
					break;
				case "ArrowLeft":
					targetIndex = currentIndex - 1;
					if (
						Math.floor(targetIndex / columns) !==
						Math.floor(currentIndex / columns)
					) {
						return;
					}
					break;
			}

			if (targetIndex >= 0 && targetIndex < productCards.length) {
				const targetCard = productCards[targetIndex];
				const firstFocusable = getFirstFocusable(targetCard);

				if (firstFocusable) {
					firstFocusable.focus();
					event.preventDefault();
				}
			}
		};

		document.addEventListener("keydown", handleKeyDown);

		const observer = new MutationObserver(() => {});

		observer.observe(collectionGrid, {
			childList: true,
			subtree: false,
		});
	}

	// // Initialize slider keyboard navigation when DOM is ready
	// document.addEventListener(
	// 	"DOMContentLoaded",
	// 	initProductSliderKeyboardNavigation
	// );
	// // Also try to initialize immediately in case DOMContentLoaded already fired
	// initProductSliderKeyboardNavigation();

	// Below are example event listeners.  They listen for theme events that Pipeline
	// fires in order to make it easier for you to add customizations.

	// Keep your scripts inside this IIFE function call to avoid leaking your
	// variables into the global scope.

	// Handle variant changes on product pages
	document.addEventListener("theme:variant:change", function (event) {
		const variant = event.detail.variant;
		if (!variant) return;

		const isProductPage = document.querySelector(".product-page");
		if (!isProductPage) return;

		const saleCopyContainer = document.querySelector("[data-sale-copy]");
		if (!saleCopyContainer) return;

		const variantTitle = variant.title.toLowerCase().replace(/[^\w]+/g, "-");
		const saleCopyElement = document.querySelector(
			`[data-sale-copy-${variantTitle}]`
		);
		const productSaleCopyElement = document.querySelector(
			"[data-product-sale-copy]"
		);

		const variantSaleCopy = saleCopyElement?.getAttribute(
			`data-sale-copy-${variantTitle}`
		);
		const productSaleCopy = productSaleCopyElement?.getAttribute(
			"data-product-sale-copy"
		);

		const saleCopy = variantSaleCopy || productSaleCopy || "";

		saleCopyContainer.innerHTML = saleCopy
			? `<p class="product__price--sale-copy">${saleCopy}</p>`
			: "";
	});

	document.addEventListener("theme:cart:change", function (event) {
		var cart = event.detail.cart;
		if (cart) {
			const cartCounts = document.querySelectorAll(".dx--cart--count");

			cartCounts.forEach((count) => {
				count.innerHTML = cart.item_count;
			});
		}
	});

	// Fired when page loads to update header values
	// document.addEventListener('theme:cart:init', (e) => {
	//   console.log('theme:cart:init');
	//   console.log(e);
	// });

	// Debounced scroll listeners.  Up and down only fire on direction changes
	// These events are useful for creating sticky elements and popups.
	// document.addEventListener('theme:scroll', e => { console.log(e); });
	// document.addEventListener('theme:scroll:up', e => { console.log(e); });
	// document.addEventListener('theme:scroll:down', e => { console.log(e); });

	// Debounced resize listener to bundle changes that trigger document reflow
	// document.addEventListener('theme:resize', e => { console.log(e); });

	// Locks and unlocks page scroll for modals and drawers
	// These are commented out because firing them will lock the page scroll
	// the lock event must set `detail` to the modal or drawer body so the
	// scroll locking code knows what element should maintain scoll.
	// document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
	// document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

	// Accessibility: Fix tab order and implement proper radiogroup keyboard navigation
	function initSwatchAccessibility() {
		const productGridItems = document.querySelectorAll("product-grid-item");

		productGridItems.forEach((item, index) => {
			const swatchContainer = item.querySelector('[role="radiogroup"]');
			if (!swatchContainer) {
				return;
			}

			const swatches = Array.from(
				swatchContainer.querySelectorAll('[role="radio"]')
			);
			if (swatches.length === 0) {
				return;
			}

			const checkedSwatch = swatches.find(
				(s) => s.getAttribute("aria-checked") === "true"
			);
			const focusableSwatch = checkedSwatch || swatches[0];

			swatches.forEach((swatch) => {
				if (swatch === focusableSwatch) {
					swatch.setAttribute("tabindex", "0");
				} else {
					swatch.setAttribute("tabindex", "-1");
				}
			});

			swatchContainer.addEventListener("keydown", (e) => {
				if (
					!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(
						e.key
					)
				) {
					return;
				}

				e.preventDefault();

				const currentIndex = swatches.indexOf(e.target);
				if (currentIndex === -1) return;

				let targetIndex;
				if (e.key === "ArrowRight" || e.key === "ArrowDown") {
					targetIndex = (currentIndex + 1) % swatches.length;
				} else {
					targetIndex =
						currentIndex === 0 ? swatches.length - 1 : currentIndex - 1;
				}

				const targetSwatch = swatches[targetIndex];

				swatches.forEach((s) => s.setAttribute("tabindex", "-1"));
				targetSwatch.setAttribute("tabindex", "0");

				targetSwatch.focus();

				targetSwatch.click();
			});

			swatches.forEach((swatch) => {
				swatch.addEventListener("click", () => {
					swatches.forEach((s) => s.setAttribute("tabindex", "-1"));
					swatch.setAttribute("tabindex", "0");
				});
			});
		});
	}

	// Run on page load
	document.addEventListener("DOMContentLoaded", initSwatchAccessibility);

	// Re-run when products are dynamically loaded
	const observeSwatchChanges = () => {
		const containers = document.querySelectorAll(
			".collection__products, .section-carousel, [data-section-type='section-carousel']"
		);

		containers.forEach((container) => {
			const observer = new MutationObserver(() => {
				initSwatchAccessibility();
			});

			observer.observe(container, {
				childList: true,
				subtree: true,
			});
		});
	};

	document.addEventListener("DOMContentLoaded", observeSwatchChanges);
	observeSwatchChanges();
	initSwatchAccessibility();

	// Accessibility: Product image slider keyboard navigation
	// Allows keyboard users to navigate through product images using left/right arrow keys
	// when focused on product card. Includes visual focus indicators and screen reader announcements.
	function initProductImageSliderAccessibility() {
		const productGridItems = document.querySelectorAll(
			"product-grid-item:not([data-image-slider-initialized])"
		);

		productGridItems.forEach((item) => {
			const variants = item.querySelectorAll("product-grid-item-variant");

			variants.forEach((variant) => {
				const imagesHolder = variant.querySelector("[data-grid-images]");
				const productLink = variant.querySelector("[data-grid-link]");

				if (!imagesHolder || !productLink) {
					return;
				}

				const images = Array.from(
					imagesHolder.querySelectorAll("product-grid-item-image")
				);

				if (images.length <= 1) {
					return;
				}

				const galleryControl = document.createElement("div");
				galleryControl.className = "gallery-control";
				galleryControl.setAttribute("role", "slider");
				galleryControl.setAttribute("tabindex", "0");
				galleryControl.setAttribute("aria-valuemin", "1");
				galleryControl.setAttribute(
					"aria-valuemax",
					images.length.toString()
				);
				galleryControl.setAttribute("aria-valuenow", "1");
				galleryControl.setAttribute(
					"aria-valuetext",
					`Image 1 of ${images.length}`
				);
				imagesHolder.appendChild(galleryControl);
				imagesHolder.setAttribute("role", "region");

				const prevButton = document.createElement("button");
				prevButton.className = "visually-hidden";
				prevButton.setAttribute("aria-label", "Previous image");
				prevButton.setAttribute("tabindex", "-1");

				const nextButton = document.createElement("button");
				nextButton.className = "visually-hidden";
				nextButton.setAttribute("aria-label", "Next image");
				nextButton.setAttribute("tabindex", "-1");

				galleryControl.appendChild(prevButton);
				galleryControl.appendChild(nextButton);

				let focusLiveRegion = variant.querySelector(
					".image-slider-focus-sr-only"
				);
				if (!focusLiveRegion) {
					focusLiveRegion = document.createElement("div");
					focusLiveRegion.className = "visually-hidden";
					focusLiveRegion.classList.add("image-slider-focus-sr-only");
					focusLiveRegion.setAttribute("aria-live", "polite");
					focusLiveRegion.setAttribute("aria-atomic", "true");
					variant.appendChild(focusLiveRegion);
				}

				let navLiveRegion = variant.querySelector(
					".image-slider-nav-sr-only"
				);
				if (!navLiveRegion) {
					navLiveRegion = document.createElement("div");
					navLiveRegion.className = "visually-hidden";
					navLiveRegion.classList.add("image-slider-nav-sr-only");
					navLiveRegion.setAttribute("aria-live", "assertive");
					navLiveRegion.setAttribute("aria-atomic", "true");
					variant.appendChild(navLiveRegion);
				}

				const updateSliderImage = (targetIndex) => {
					images.forEach((img) => {
						img.removeAttribute("data-grid-current-image");
					});

					const targetImage = images[targetIndex];
					if (targetImage) {
						targetImage.setAttribute("data-grid-current-image", "true");
						targetImage.setAttribute("loading", "eager");

						galleryControl.setAttribute(
							"aria-valuenow",
							(targetIndex + 1).toString()
						);
						galleryControl.setAttribute(
							"aria-valuetext",
							`Image ${targetIndex + 1} of ${images.length}`
						);

						const pagination = variant.querySelector(
							"[data-grid-pagination]"
						);
						if (pagination) {
							const pages =
								pagination.querySelectorAll("[data-grid-page]");
							pages.forEach((page) => {
								page.classList.remove("is-active");
								page.style.setProperty("--width", "100%");
							});

							const targetPage = pagination.querySelector(
								`[data-grid-page="${targetIndex}"]`
							);
							if (targetPage) {
								targetPage.classList.add("is-active");
							}
						}
					}
				};

				const handleImageSliderKeydown = (e) => {
					if (
						!["ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)
					) {
						return;
					}

					const swatchContainer = e.target.closest('[role="radiogroup"]');
					if (swatchContainer) {
						return;
					}

					e.preventDefault();

					if (variant.pagingProgressPause !== undefined) {
						variant.pagingProgressPause = true;
					}

					let currentIndex = 0;
					const currentImage = imagesHolder.querySelector(
						"[data-grid-current-image]"
					);
					if (currentImage) {
						const indexAttr =
							currentImage.getAttribute("data-grid-image");
						currentIndex = parseInt(indexAttr, 10) || 0;
					}

					let targetIndex;
					switch (e.key) {
						case "ArrowRight":
							targetIndex = (currentIndex + 1) % images.length;
							break;
						case "ArrowLeft":
							targetIndex =
								currentIndex === 0
									? images.length - 1
									: currentIndex - 1;
							break;
						case "Home":
							targetIndex = 0;
							break;
						case "End":
							targetIndex = images.length - 1;
							break;
					}

					updateSliderImage(targetIndex);

					const targetImage = images[targetIndex];
					const imageAlt =
						targetImage.querySelector("img")?.getAttribute("alt") || "";

					navLiveRegion.textContent = imageAlt ? `${imageAlt}.` : ``;
				};

				galleryControl.addEventListener(
					"keydown",
					handleImageSliderKeydown
				);

				prevButton.addEventListener("click", () => {
					const currentIndex =
						parseInt(galleryControl.getAttribute("aria-valuenow")) - 1;
					const targetIndex =
						currentIndex === 0 ? images.length - 1 : currentIndex - 1;
					updateSliderImage(targetIndex);
				});

				nextButton.addEventListener("click", () => {
					const currentIndex =
						parseInt(galleryControl.getAttribute("aria-valuenow")) - 1;
					const targetIndex = (currentIndex + 1) % images.length;
					updateSliderImage(targetIndex);
				});

				const handleFocus = () => {
						imagesHolder.classList.add("keyboard-focused");
						galleryControl.classList.add("is-visible");
					},
					handleBlur = () => {
						imagesHolder.classList.remove("keyboard-focused");
						galleryControl.classList.remove("is-visible");

						focusLiveRegion.textContent = "";
						navLiveRegion.textContent = "";
					};

				galleryControl.addEventListener("focus", handleFocus);
				galleryControl.addEventListener("blur", handleBlur);
			});

			item.setAttribute("data-image-slider-initialized", "true");
		});
	}

	document.addEventListener(
		"DOMContentLoaded",
		initProductImageSliderAccessibility
	);
	if (document.readyState === "loading") {
	} else {
		initProductImageSliderAccessibility();
	}

	let imageSliderObserverTimeout;
	const observeImageSliderChanges = () => {
		const containers = document.querySelectorAll(
			".collection__products, .section-carousel, [data-section-type='section-carousel']"
		);

		containers.forEach((container) => {
			const observer = new MutationObserver(() => {
				clearTimeout(imageSliderObserverTimeout);
				imageSliderObserverTimeout = setTimeout(() => {
					initProductImageSliderAccessibility();
				}, 200);
			});

			observer.observe(container, {
				childList: true,
				subtree: false,
			});
		});
	};

	document.addEventListener("DOMContentLoaded", observeImageSliderChanges);
	if (document.readyState === "loading") {
	} else {
		observeImageSliderChanges();
	}

	// ^^ Keep your scripts inside this IIFE function call to avoid leaking your
	// variables into the global scope.
})();
